import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Navbar, Nav, Container, Badge, Dropdown } from 'react-bootstrap';
import { api } from '../../../config';

function Navbarpro() {
  const location = useLocation();
  const navigate = useNavigate();
  const [pendingCount, setPendingCount] = useState(0);
  const [adminInfo, setAdminInfo] = useState(null);

  useEffect(() => {
    // Fetch pending count
    api.get('/vendor/countofpendingrequest')
      .then(res => setPendingCount(res.data?.valueofrequest || 0))
      .catch(() => { });

    // Get admin info from localStorage
    try {
      const info = localStorage.getItem('adminInfo');
      if (info) setAdminInfo(JSON.parse(info));
    } catch { }
  }, []);

  const handleLogout = async () => {
    try {
      await api.post('/logout');
    } catch { }
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('adminInfo');
    navigate('/admin_login');
  };

  const navLinks = [
    { to: '/', icon: 'bi-speedometer2', label: 'Dashboard' },
    { to: '/vendors', icon: 'bi-shop-window', label: 'Vendors' },
    { to: '/pending', icon: 'bi-clock-history', label: 'Pending', badge: pendingCount },
    { to: '/customers', icon: 'bi-people', label: 'Customers' },
    { to: '/orders', icon: 'bi-bag', label: 'Orders' },
    { to: '/categories', icon: 'bi-grid', label: 'Categories' },
    { to: '/vendor', icon: 'bi-plus-circle', label: 'Add Vendor' },
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <>
      <Navbar expand="lg" className="py-2" sticky="top">
        <Container fluid className="px-4">
          <Navbar.Brand as={Link} to="/" className="d-flex align-items-center gap-2">
            <div style={{
              width: 42,
              height: 42,
              borderRadius: '10px',
              background: 'var(--gradient-primary)',
              padding: '4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <img src="/logo.png" alt="Apna Mestri" style={{ height: 32, width: 32, objectFit: 'contain' }} />
            </div>
            <div className="d-flex flex-column">
              <span className="fw-bold" style={{ fontSize: '1.1rem', lineHeight: 1.2 }}>Apna Mestri</span>
              <Badge bg="warning" text="dark" style={{ fontSize: '0.6rem', width: 'fit-content' }}>ADMIN PANEL</Badge>
            </div>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="main-navbar" className="border-0">
            <i className="bi bi-list fs-4 text-white"></i>
          </Navbar.Toggle>

          <Navbar.Collapse id="main-navbar">
            <Nav className="mx-auto">
              {navLinks.map(({ to, icon, label, badge }) => (
                <Nav.Link
                  as={Link}
                  to={to}
                  key={to}
                  className={`mx-1 px-3 py-2 position-relative ${isActive(to) ? 'active' : ''}`}
                  style={{
                    color: isActive(to) ? 'var(--primary)' : 'var(--text-secondary)',
                    background: isActive(to) ? 'rgba(255, 118, 0, 0.1)' : 'transparent',
                    borderRadius: '8px',
                    transition: 'all 0.2s ease'
                  }}
                >
                  <i className={`bi ${icon} me-2`}></i>
                  {label}
                  {badge > 0 && (
                    <Badge
                      bg="danger"
                      className="ms-2"
                      style={{ fontSize: '0.65rem' }}
                    >
                      {badge}
                    </Badge>
                  )}
                </Nav.Link>
              ))}
            </Nav>

            {/* Right side - Profile dropdown */}
            <Nav className="align-items-center">
              <Dropdown align="end">
                <Dropdown.Toggle
                  variant="link"
                  className="d-flex align-items-center gap-2 text-decoration-none p-0"
                  style={{ color: 'var(--text-primary)' }}
                >
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center"
                    style={{
                      width: 36,
                      height: 36,
                      background: 'var(--gradient-primary)',
                      color: '#fff'
                    }}
                  >
                    <i className="bi bi-person"></i>
                  </div>
                  <span className="d-none d-lg-inline">{adminInfo?.email?.split('@')[0] || 'Admin'}</span>
                </Dropdown.Toggle>

                <Dropdown.Menu
                  style={{
                    background: 'var(--bg-card)',
                    border: '1px solid var(--border-color)',
                    minWidth: '200px'
                  }}
                >
                  <Dropdown.Header style={{ color: 'var(--text-secondary)' }}>
                    <small>Logged in as</small>
                    <div style={{ color: 'var(--text-primary)' }}>{adminInfo?.email || 'Admin'}</div>
                  </Dropdown.Header>
                  <Dropdown.Divider style={{ borderColor: 'var(--border-color)' }} />
                  <Dropdown.Item
                    as={Link}
                    to="/notification"
                    style={{ color: 'var(--text-primary)' }}
                  >
                    <i className="bi bi-bell me-2"></i> Notifications
                  </Dropdown.Item>
                  <Dropdown.Divider style={{ borderColor: 'var(--border-color)' }} />
                  <Dropdown.Item
                    onClick={handleLogout}
                    style={{ color: 'var(--accent-red)' }}
                  >
                    <i className="bi bi-box-arrow-left me-2"></i> Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Mobile Bottom Nav */}
      <Navbar
        fixed="bottom"
        className="d-flex d-lg-none justify-content-around py-2"
        style={{
          background: 'var(--bg-secondary)',
          borderTop: '1px solid var(--border-color)'
        }}
      >
        {navLinks.slice(0, 5).map(({ to, icon, badge }) => (
          <Nav.Link
            as={Link}
            to={to}
            key={to}
            className="text-center position-relative p-2"
            style={{
              color: isActive(to) ? 'var(--primary)' : 'var(--text-muted)',
              transition: 'all 0.2s ease'
            }}
          >
            <i className={`bi ${icon} fs-5`}></i>
            {badge > 0 && (
              <Badge
                bg="danger"
                className="position-absolute"
                style={{ top: 0, right: 0, fontSize: '0.6rem' }}
              >
                {badge}
              </Badge>
            )}
          </Nav.Link>
        ))}
      </Navbar>
    </>
  );
}

export default Navbarpro;
